export default "__VITE_ASSET__CTJV$DQD__"